import { Feature } from '@/models';
import { GenericService } from '@/services/api/generic.service';

export class FeatureFlagService extends GenericService<Feature> {
  constructor() {
    super('v1/feature-flags');
  }
}
